import { render, staticRenderFns } from "./ReportBoxTopProducts.vue?vue&type=template&id=35811485&scoped=true&"
import script from "./ReportBoxTopProducts.vue?vue&type=script&lang=js&"
export * from "./ReportBoxTopProducts.vue?vue&type=script&lang=js&"
import style0 from "./ReportBoxTopProducts.vue?vue&type=style&index=0&id=35811485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35811485",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35811485')) {
      api.createRecord('35811485', component.options)
    } else {
      api.reload('35811485', component.options)
    }
    module.hot.accept("./ReportBoxTopProducts.vue?vue&type=template&id=35811485&scoped=true&", function () {
      api.rerender('35811485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportBoxTopProducts.vue"
export default component.exports